import { createContext, ReactNode, useContext, useState } from 'react';
import { ICompany } from '@/types/api/companies';

interface IInstitutionalPageContext {
  children: ReactNode;
  initialCompany: ICompany;
}

interface IInstitutionalPageContextData<T = ICompany> {
  company: T;
  updateCompany: (companyUpdated: Partial<ICompany>) => void;
}

export const InstitutionalPageContext =
  createContext<IInstitutionalPageContextData | null>(null);

export function InstitutionalPageProvider({
  children,
  initialCompany,
}: IInstitutionalPageContext) {
  const [company, setCompany] = useState<ICompany>(initialCompany);

  const updateCompany = (companyUpdated: Partial<ICompany>) => {
    setCompany(prevState => ({
      ...prevState,
      ...companyUpdated,
    }));
  };
  return (
    <InstitutionalPageContext.Provider
      value={{
        company,
        updateCompany,
      }}
    >
      {children}
    </InstitutionalPageContext.Provider>
  );
}

export const useInstitutionalPage = () => {
  const context = useContext(InstitutionalPageContext);

  if (!context) {
    throw Error('Must be inside a InstitutionalPageProvider');
  }

  return context;
};

export type { IInstitutionalPageContextData };
